import { MessageSquare } from "lucide-react";

interface CaseChatButtonViewProps {
  onClick: () => void;
}

export const CaseChatButtonView = ({ onClick }: CaseChatButtonViewProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Open case chat"
      className="fixed bottom-6 right-6 z-fixed flex h-[3.25rem] w-[3.25rem] items-center justify-center rounded-full border-none bg-primary text-primary-foreground [box-shadow:0_4px_12px_hsl(var(--primary)/0.35),0_1px_3px_rgba(0,0,0,0.1)] [transition:transform_0.15s_ease,box-shadow_0.15s_ease] hover:[box-shadow:0_6px_16px_hsl(var(--primary)/0.4),0_2px_4px_rgba(0,0,0,0.12)] focus-visible:shadow-focus active:scale-[0.98]"
    >
      <MessageSquare size={22} />
    </button>
  );
};
